/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Form,
  theme,
  Row,
  Button,
  Col,
  Input,
  message,
  Modal,
  Select,
} from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import axios from "axios";
import localhost from "../../constants/localhost";
import AddModal from "./addModal";

export const KEYS = {
  PERMISSION_NAME: "name",
  PERMISSION: "code",
  ACCOUT: "account",
  ACCOUNT_TYPE: "accountChannel",
  AFFILIATION: "accountOwner",
  CREATOR: "creator",
  CREATE_TIME: "createDate",
  UPDATE_TIME: "modifyDate",
};

export const KEYS_TEST = {
  [KEYS.PERMISSION_NAME]: "权限名称",
  [KEYS.PERMISSION]: "权限编码",
  [KEYS.ACCOUT]: "帐号",
  [KEYS.ACCOUNT_TYPE]: "帐号渠道",
  [KEYS.AFFILIATION]: "帐号归属",
  [KEYS.CREATOR]: "创建人",
  [KEYS.CREATE_TIME]: "创建时间",
  [KEYS.UPDATE_TIME]: "更新时间",
};

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      [KEYS.PERMISSION_NAME]: "设置178002883视频号权",
      [KEYS.PERMISSION]: "admin01",
      [KEYS.ACCOUT]: "17800288",
      [KEYS.ACCOUNT_TYPE]: "小红书",
      [KEYS.AFFILIATION]: "运营1222",
      [KEYS.CREATOR]: "花好月圆",
      [KEYS.CREATE_TIME]: "2025-10-11 12:00:00",
      [KEYS.UPDATE_TIME]: "2025-10-11 12:00:00",
    };
  });

const UserMng = ({ pageMode, updateSelectedRowKeys }) => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({
    total: 20,
    dataSource: mockData,
  });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    axios
      .post(`${localhost}/manage/authority/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const columns = [
    {
      title: KEYS_TEST[KEYS.PERMISSION_NAME],
      dataIndex: KEYS.PERMISSION_NAME,
      minWidth: 120,
      fixed: "left",
    },
    {
      title: KEYS_TEST[KEYS.PERMISSION],
      dataIndex: KEYS.PERMISSION,
      minWidth: 120,
    },
    {
      title: KEYS_TEST[KEYS.ACCOUT],
      dataIndex: KEYS.ACCOUT,
      minWidth: 120,
    },
    {
      title: KEYS_TEST[KEYS.ACCOUNT_TYPE],
      dataIndex: KEYS.ACCOUNT_TYPE,
      minWidth: 120,
    },
    {
      title: KEYS_TEST[KEYS.AFFILIATION],
      dataIndex: KEYS.AFFILIATION,
      minWidth: 120,
    },
    {
      title: KEYS_TEST[KEYS.CREATOR],
      dataIndex: KEYS.CREATOR,
    },
    {
      title: KEYS_TEST[KEYS.CREATE_TIME],
      dataIndex: KEYS.CREATE_TIME,
    },
    {
      title: KEYS_TEST[KEYS.UPDATE_TIME],
      dataIndex: KEYS.UPDATE_TIME,
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <AddModal mode="edit" detail={record} getData={getData} />
          <a
            onClick={() => {
              Modal.confirm({
                width: 450,
                title: `请确认是否进行删除操作！`,
                icon: <ExclamationCircleFilled />,
                content: "温馨提示：删除之后可能会影响客户操作！",
                okText: "确定",
                cancelText: "取消",
                onOk() {
                  axios
                    .get(`${localhost}/manage/authority/delete?id=${record.id}`)
                    .then((res) => {
                      message.success("删除成功！");
                      setPageInfo({ pageNo: 1, pageSize: 10 });
                      getData();
                    })
                    .catch((error) => {
                      message.error("网络异常，请重试！");
                    });
                },
                onCancel() {},
              });
            }}
          >
            删除
          </a>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Form form={form} style={formStyle} onFinish={onFinish}>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label={KEYS_TEST[KEYS.PERMISSION_NAME]}
                name={KEYS.PERMISSION_NAME}
              >
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={KEYS_TEST[KEYS.PERMISSION]}
                name={KEYS.PERMISSION}
              >
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={KEYS_TEST[KEYS.ACCOUNT_TYPE]}
                name={KEYS.ACCOUNT_TYPE}
              >
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={KEYS_TEST[KEYS.CREATOR]} name={KEYS.CREATOR}>
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={16}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      {pageMode !== "connent" && (
        <div style={{ textAlign: "right" }}>
          <AddModal mode="create" getData={getData} />
        </div>
      )}
      <div style={{ marginTop: 16 }}>
        <Table
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
              updateSelectedRowKeys(keys);
            },
          }}
          // loading={loading}
          dataSource={dataInfo.dataSource}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default UserMng;
